import React, { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Drawer, CircularProgress, Box } from '@mui/material';

import { getCharacterTemplate } from '../../../services/characterRequests';
import Template from './Template';

const useStyles = makeStyles({
	drawerContent: {
		height: 'calc(100% - 64px)',
		overflowY: 'auto',
		marginTop: '64px',
		minWdith: '300px',
	},
});

const CharacterTemplateViewer = ({ minimalTemplate, onClose }) => {
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState(true);
	const [template, setTemplate] = useState(null);
	const [drawerOpen, setDrawerOpen] = useState(false);

	useEffect(() => {
		const fetchTemplate = async () => {
			try {
				const response = await getCharacterTemplate(minimalTemplate.ID);
				setTemplate(response);
				setIsLoading(false);
			} catch (error) {
				console.log('Error getting character template', error);
			}
		};
		if (minimalTemplate && minimalTemplate.ID !== template?.ID) {
			setTemplate({
				minimalTemplate,
				sections: [],
			});
			handleOpenDrawer();
			fetchTemplate();
		}
	}, [minimalTemplate]);

	const handleOpenDrawer = () => {
		setDrawerOpen(true);
	};

	const handleCloseDrawer = () => {
		setDrawerOpen(false);
		onClose();
		setTemplate();
		setIsLoading(true);
	};

	return (
		<>
			<Drawer anchor="right" open={drawerOpen} onClose={handleCloseDrawer}>
				<Box className={classes.drawerContent} p={2}>
					{isLoading ? (
						<CircularProgress color="inherit" />
					) : (
						<Template template={template} />
					)}
				</Box>
			</Drawer>
		</>
	);
};

export default CharacterTemplateViewer;
